<template>
  <div>
    <div>
      <a-form :label-col="{ span: 5 }" :wrapper-col="{ span: 17 }">
        <a-row>
          <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
            <a-form-item label="链接地址">
              <a-input v-model="searchForm.path" allowClear placeholder="请输入" style="width: 100%" />
            </a-form-item>
          </a-col>
          <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
            <a-form-item label="创建时间">
              <v-range-picker v-model="times" @change="onChange" :placeholder="['开始时间', '结束时间']" />
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 搜索按钮 -->
    <div class="flex-sb">
      <div>
        <a-button type="primary" @click="handleAdd">新增链接</a-button>
      </div>
      <div>
        <a-button type="primary" icon="search" style="margin-right: 20px;" @click="search">查询</a-button>
        <a-button type="primary" icon="delete" ghost @click="handleClear">清空</a-button>
      </div>
    </div>
    <!-- 表格 -->
    <a-table row-key="id" :columns="columnsArticle" :loading="loading" :data-source="data" :pagination="pagination" style="margin-top: 20px" @change="handleTableChange">
      <template slot="operator" slot-scope="text, record">
        <div class="flex-c-ac">
          <a-button size="small" type="link" @click="handleTableCommand('edit', record)">编辑</a-button>
          <a-button size="small" type="link" style="margin-left: 20px" @click="del(record)">删除</a-button>
        </div>
      </template>
    </a-table>

    <!-- 添加公司 -->
    <AddArticle v-model="visible" :isEdit="isEdit" :params="waitItem" @handleOver="getList" />
  </div>
</template>
<script>
import { ref, reactive, onMounted, toRefs, getCurrentInstance, computed } from '@vue/composition-api'
import { columnsArticle, articleSearchForm } from './business/filialeList'
import { strategyCommand } from './business/tableList'
import pagination from '@/composables/pagination'
import AddArticle from './components/AddArticle'
import api from '@/api/'
import store from '@/store/'

export default {
  components: { AddArticle },
  setup(props, { root }) {
    // 获取当前实例
    const _this = getCurrentInstance()
    const state = reactive({
      times: [],
      searchForm: { ...articleSearchForm },
      columnsArticle,
      platformList: []
    })

    onMounted(async () => {
      await methods.getPlatform()
      methods.getList()
    })
    const methods = {
      async getList() {
        _this.loading = true
        const res = await api.deadLinksList({
          ..._this.searchForm,
          project: _this.$route.query.project,
          page: _this.pagination.current,
          per_page: _this.pagination.pageSize
        })
        const { die_links, pagination } = res.data
        _this.data = die_links
        _this.pagination.total = pagination.total
        _this.loading = false
      },

      async getPlatform() {
        const res = await api.LineListNew()
        state.platformList = res.data
      },

      search() {
        _this.pagination.current = 1
        this.getList()
      },

      onChange(date, dateString) {
        state.searchForm.created_at_start = dateString[0]
        state.searchForm.created_at_end = dateString[1]
      },

      handleClear() {
        state.searchForm = { ...articleSearchForm }
        state.times = []
        this.search()
      },

      // 表格变化事件
      handleTableCommand(type, ...arg) {
        strategyCommand[type].call(_this, ...arg)
      },
      async del(data) {
        this.$confirm({
          title: '是否确定删除？',
          okText: '确认',
          cancelText: '取消',
          onOk: async () => {
            const res = await api.deadLinksDetail({ id: data.id })
            if (_this.$validate(res)) {
              _this.$message.success('删除成功~')
              _this.getList()
            }
          }
        })
      },
      handleAdd() {
        _this.visible = true
        _this.isEdit = false
      }
    }

    return {
      ...toRefs(state),
      ...pagination(),
      ...methods
    }
  }
}
</script>
